// Welcome modal displayed on the first step of the user guide

import React from "react";
import Image from "../../../../../Assets/Images/Welcome-modal-banner.svg";
import Logo from "../../../../../Assets/Images/CX_LOGO_32PX.svg";

const WelcomeModal = (props) => {
  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };
  return (
    <div className="welcome-modal">
      <img className="cx-logo" alt="CX" src={Logo} />
      <img className="vector" alt="" src={Image} />
      <section className="text-holder">
        <h1>{translateText("welcome_to_cx")} </h1>
        <p>{translateText("cx_slogan")}</p>
      </section>
      <span onClick={() => props.Skip()} className="skip-btn">
        {translateText("skip")}
      </span>
      <span onClick={() => props.Start()} className="start-btn">
        {translateText("lets_start")}
      </span>
    </div>
  );
};

export default WelcomeModal;
